import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import {BrowserRouter} from "react-router-dom";
import ClearLSErrorBoundary from "./components/ClearLSErrorBoundary/ClearLSErrorBoundary";

const confSiteUrl = process.env.NODE_ENV === "development" ? "/" : process.env.PUBLIC_URL;

try {
    const rootElement = document.getElementById("root");
    if (rootElement) {
        const root = ReactDOM.createRoot(rootElement);
        root.render(
            <React.StrictMode>
                <BrowserRouter basename={confSiteUrl}>
                    <ClearLSErrorBoundary>
                        <App/>
                    </ClearLSErrorBoundary>
                </BrowserRouter>
            </React.StrictMode>
        );
    }
} catch (e) {
    localStorage.clear()
}


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
